import { Auth } from '@/utils/access_control';

export default {
  inserted(el, binding) {
    if (!binding.value) {
      throw new Error('Permission name not defined.');
    }
    if (!Auth.authorized(binding.value)) {
      el.remove();
    }
  },
};



// WEBPACK FOOTER //
// ./src/directives/authorization.js